import { CdkScrollable } from '@angular/cdk/scrolling';

import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton, MatMiniFabButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { select, Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { SavedMatchInfoModel } from 'models/saved-matches';
import { Subject, takeUntil } from 'rxjs';
import { AppState, matchesActions } from 'store';
import { selectSaved } from 'store/matches/matches.reducers';
import { LuxonPipe } from '../../pipes/luxon.pipe';

@Component({
    selector: 'app-load-saved-match',
    templateUrl: './load-saved-match.component.html',
    styleUrls: ['./load-saved-match.component.scss'],
    imports: [
        MatDialogTitle,
        FormsModule,
        CdkScrollable,
        MatDialogContent,
        MatSelectionList,
        MatListOption,
        MatMiniFabButton,
        MatIcon,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        TranslateModule,
        LuxonPipe,
    ],
})
export class LoadSavedMatchComponent implements OnInit, OnDestroy {
    private readonly dialogRef = inject<MatDialogRef<LoadSavedMatchComponent>>(MatDialogRef);
    private readonly store = inject<Store<AppState>>(Store);

    public savedMatches: Array<SavedMatchInfoModel>;
    #unsubscribe = new Subject<void>();

    ngOnInit(): void {
        this.store.pipe(select(selectSaved), takeUntil(this.#unsubscribe)).subscribe((x) => (this.savedMatches = x));
        this.store.dispatch(matchesActions.loadSavedMatches());
    }

    ngOnDestroy(): void {
        this.#unsubscribe.next();
        this.#unsubscribe.complete();
    }

    public loadMatch(value: SavedMatchInfoModel) {
        this.store.dispatch(matchesActions.restoreSavedMatch({ id: value.id }));
        this.dialogRef.close();
    }
}
